import { ServerError } from "@/types/errors";
import { LoginForm, UserProfile } from "@/types/user";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


export const login = createAsyncThunk<UserProfile, LoginForm>("users/login", async (data,{rejectWithValue}) => {
  const headers = {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  };
  try{
    const response = await axios.post("/api/v4/users/login", data, { headers: headers });
    localStorage.setItem("token",response.headers["token"]);
    return response.data;
  }catch(error:any) {
    return rejectWithValue(error.response.data)
  }
});
